export default "__VITE_ASSET__DzxbaMEY__"